// extracted by mini-css-extract-plugin
export default {"coveredBackground":"СoveredBackground_coveredBackground__MNL0K","coveredBackground__item":"СoveredBackground_coveredBackground__item__3vThs"};